import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Pasás domingos enteros tipando guías de actividades sobre energía solar en lugar de descansar', 'Tus evaluaciones son siempre las mismas porque no tenés un banco de preguntas variadas', 'Cuando un alumno pregunta por hidrógeno verde o biogás no tenés material para mostrarle', 'Cada año empezás de cero la planificación aunque el programa sea casi el mismo', 'No tenés actividades listas para que el alumno trabaje en clase sin perder tiempo', 'Tus presentaciones no tienen soporte visual y los alumnos se desconectan a los 10 minutos', 'Querés enseñar proyectos para feria de ciencias pero no sabés cómo estructurarlos', 'Sentís que tu material no está al nivel de lo que la transición energética exige hoy'];
  return <section className="py-20 bg-[#06140d]" data-id="element-288">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-289">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-290">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-291">
            ❓ ¿Cuántas clases más vas a improvisar por no tener el material
            correcto?
          </h2>

          <div className="space-y-6 text-lg text-slate-300 text-left md:text-center max-w-3xl mx-auto" data-id="element-292">
            <p className="text-[14px]" data-id="element-293">
              Tal vez ya descargaste PDFs sueltos de internet que no tienen
              secuencia didáctica. Tal vez armás tus propias actividades desde
              cero cada año. Tal vez buscás evaluaciones en foros y llegás al
              aula con material que no tiene clave de corrección.
            </p>
            <p data-id="element-294">
              <strong className="text-white text-[16px]" data-id="element-295">
                No es falta de conocimiento técnico. Es que nadie armó el
                sistema completo para vos.
              </strong>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-emerald-950/30 border border-emerald-900/50 rounded-2xl p-6 md:p-8" data-id="element-296">
          <h3 className="text-xl font-bold text-slate-200 mb-6 text-center" data-id="element-297">
            😓 Esto te está pasando ahora mismo:
          </h3>
          <ul className="space-y-4" data-id="element-298">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-299">
                <div className="mt-1 bg-emerald-500/20 p-1 rounded-full shrink-0" data-id="element-300">
                  <X className="w-4 h-4 text-emerald-400" data-id="element-301" />
                </div>
                <span className="text-slate-200 font-medium text-[14px]" data-id="element-302">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-303">
          <p className="font-bold text-slate-300 text-[16px]" data-id="element-304">
            ¿Y si esta fuera la última semana que preparás clases desde cero?
          </p>
        </div>
      </div>
    </section>;
}